export default {
    'Search for a location': 'Zoek een locatie',
    'No results found': 'Geen resultaten gevonden',
    'Could not load address details': 'Kon adresgegevens niet laden',
    'Due to an unforeseen error, the address details could not be loaded.': 'Door een onvoorziene fout konden de adresgegevens niet worden geladen.',
    'Manual address entry': 'Handmatige adresinvoer',
};
